module.exports = __webpack_public_path__ + "img/background-may-britt-3.png";